import { useEffect, useRef } from 'react';

export const useImagePreloader = (images: string[]) => {
  const loadedImagesRef = useRef<Set<string>>(new Set());

  useEffect(() => {
    if (!images || images.length === 0) return;

    const imagesToLoad = images.filter(src => !loadedImagesRef.current.has(src));
    
    if (imagesToLoad.length === 0) return;

    const preloadedImages: HTMLImageElement[] = [];

    imagesToLoad.forEach(src => {
      const img = new Image();
      img.src = src;
      preloadedImages.push(img);
      loadedImagesRef.current.add(src);
    });

    return () => {
      preloadedImages.length = 0;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [images.join(',')]);
};

export default useImagePreloader;
